<template>
  <section>
    <div class="bg-white border border-red-500 rounded-xl mt-4">
      <div
        class="px-4 py-5 sm:p-6 items-center justify-between"
        id="delete-btn-div"
      >
        <div class="">
          <h3 class="text-lg leading-6 font-medium text-neutral-900">
            {{ $t('Delete this project') }}
          </h3>
          <div class="mt-2 max-w-xl text-sm text-neutral-600">
            <p>
              {{ $t('Once you delete this project, you will lose all data associated with it.') }}
            </p>
          </div>
        </div>
        <button
          id="delete-btn"
          type="button"
          @click.prevent="dialogVisible = true"
          class="btn-danger-outline"
        >
          {{ $t('Delete this project') }}
        </button>
      </div>
    </div>

    <Dialog :title="$t('Confirmation')" v-model="dialogVisible">
      <div class="px-4 py-4 sm:px-6">
        <h2 class="text-lg text-neutral-900">
          {{ $t('You are about to permanently delete this project') }}
        </h2>

        <p class="mt-4">
          {{ $t('This action cannot be undone. This will permanently delete the') }}
          <strong>{{ this.projectSubdomain }}.feedbear.com</strong> {{ $t('project, boards, ideas, comments, votes, and remove all collaborator associations.') }}
        </p>

        <div class="flex justify-end items-center mt-4 space-x-2">
          <button class="btn-secondary" @click="dialogVisible = false">{{ $t('Cancel') }}</button>
          <slot name="delete_button"></slot>
        </div>
      </div>
    </Dialog>
  </section>
</template>

<script>
import Dialog from "../../components/dialog";

export default {
  props: ["project-id", "project-subdomain", "current-user-handle"],
  data() {
    return {
      dialogVisible: false,
    };
  },
  components: {
    Dialog,
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
#delete-btn-div {
  display: flex;
}

@media only screen and (max-width: 480px) {
  #delete-btn-div {
    display: block;

    #delete-btn {
      width: -webkit-fill-available;
      margin-top: 1rem;
    }
  }
}
</style>
